import { Flex, Typography, useDevice } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { ergopadAsset } from '../../common/assets/ergopadAsset';
import { AssetIcon } from '../../common/components/AssetIcon/AssetIcon';
import { ReactComponent as Coin } from './coin.svg';

export const Title: FC<{ isClaim: boolean }> = ({ isClaim }) => {
  const { valBySize, lessThan } = useDevice();

  return (
    <Flex
      justify="space-between"
      align="center"
      width="100%"
      style={{ height: valBySize(108, 244, 400) }}
    >
      <Flex.Item display="flex" col>
        <Typography.Title
          level={1}
          style={{
            fontSize: valBySize(24, 46, 56),
            lineHeight: `${valBySize(32, 54, 64)}px`,
          }}
        >
          {isClaim ? (
            'SPF Claimer'
          ) : (
            <>Spectrum Finance {lessThan('l') && <br />} IDO</>
          )}
        </Typography.Title>
        <Flex.Item marginTop={4}>
          <Typography.Title level={valBySize(5, 4, 3)}>
            <Flex align="center">
              Powered by{' '}
              <Flex.Item marginLeft={2} marginRight={1}>
                <AssetIcon asset={ergopadAsset} />
              </Flex.Item>{' '}
              Ergopad
            </Flex>
          </Typography.Title>
        </Flex.Item>
      </Flex.Item>
      <Coin
        style={{
          height: '100%',
          width: valBySize<number | string>(122, 244, 'unset'),
        }}
      />
    </Flex>
  );
};
